export default __webpack_public_path__ + "static/media/government.5309e394.jpeg";